import { fetchApi } from '@/config/axiosSetting';
import { PatchVisitFormQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchVisitForm/patchVisitFormQuery.type';

export const patchVisitFormFunction = (
  params: PatchVisitFormQueryParamsType,
) => {
  return fetchApi.patch(
    `/initial/reports/${params?.id}/visit_form/`,
    params?.data,
  );
};
